import Vue from 'vue'
import VueI18n from 'vue-i18n'
import translations from './../lang/translations.json'
import apiService from "./request"
import axios from 'axios/index'

Vue.use(VueI18n);

export const i18n = new VueI18n({
    locale: 'nl-be',
    fallbackLocale: 'nl-be',
    messages: translations
})

const loadedLanguages = ['nl-be'] // our default language that is preloaded

function setI18nLanguage (lang) {
    i18n.locale = lang
    axios.defaults.headers.common['Accept-Language'] = lang
    document.querySelector('html').setAttribute('lang', lang)
    Vue.ls.set('language', lang)

    return lang
}

export function loadLanguageAsync(lang = 'nl-be', translations = []) {
    // If the same language || If the language was already loaded
    if ((i18n.locale === lang || loadedLanguages.includes(lang)) && translations.length > 0) {
        i18n.setLocaleMessage(lang, translations[lang])

        return Promise.resolve(setI18nLanguage(lang))
    }

    // If the language hasn't been loaded yet
    return apiService.getTranslations(lang, translations => {
        for (let translation in translations) {
            if (lang === translation) {
                loadedLanguages.push(translation)
                i18n.setLocaleMessage(translation, translations[translation])

                return setI18nLanguage(translation)
            }
        }
    })
}


// WEBPACK FOOTER //
// ./src/services/i18n-setup.js